import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Upload/style";
import _Upload from "@arco-design/web-react/es/Upload";
import _IconPlus from "@arco-design/web-react/icon/react-icon/IconPlus";
import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Radio/style";
import _Radio from "@arco-design/web-react/es/Radio";
import { intl } from 'di18n-react';
/*
 * @Author: songjunlong
 * @Date: 2024-09-24 09:42:47
 * @LastEditors: songjunlong
 * @LastEditTime: 2024-09-24 09:52:43
 * @FilePath: \node-master\src\components\NavBar\Upload.tsx
 */
import { useState, useEffect } from 'react';
import { useRequest } from 'ahooks';
import { post } from '@/services';
import { EnvService } from '@/service';
import useLocale from '@/utils/useLocale';
const Cpn = props => {
  const {
    visible,
    setVisible,
    showLogo,
    refresh,
    logo
  } = props;
  const [imgSrc, setImgSrc] = useState(null);
  const [file, setFile] = useState(null);
  const [show, setShow] = useState(showLogo);
  const t = useLocale();
  const uploadPackage = params => {
    const formData = new FormData();
    file && formData.append('logo', params.file);
    formData.append('enable', params.enable);
    return post({
      url: '/resource/update',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
  const {
    runAsync: uploadPackageRun,
    loading: uploadPackageLoading
  } = useRequest(uploadPackage, {
    manual: true
    //
  });
  useEffect(() => {
    //
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Modal, {
    visible: visible,
    title: intl.t('Logo设置'),
    onCancel: () => setVisible(false),
    onOk: () => {
      // if (!file) {
      //   Notification.error({
      //     title: '提示',
      //     content: '请上传图片',
      //     duration: 2000,
      //   });
      //   return;
      // }
      const params = {
        file,
        enable: show + ''
      };
      uploadPackageRun(params).then(res => {
        refresh();
        setVisible(false);
      });
    },
    style: {
      width: 600
    }
  }, /*#__PURE__*/React.createElement(_Form, null, /*#__PURE__*/React.createElement(_Form.Item, {
    label: intl.t('是否显示Logo')
  }, /*#__PURE__*/React.createElement(_Radio.Group, {
    value: show,
    onChange: v => setShow(v)
  }, /*#__PURE__*/React.createElement(_Radio, {
    value: true
  }, intl.t('显示')), /*#__PURE__*/React.createElement(_Radio, {
    value: false
  }, intl.t('隐藏')))), /*#__PURE__*/React.createElement(_Form.Item, {
    label: intl.t('Logo图片')
  }, /*#__PURE__*/React.createElement(_Upload, {
    accept: "image/*",
    fileList: [],
    showUploadList: false,
    beforeUpload: file => {
      //如果大于2M,提示
      if (file.size > 2 * 1024 * 1024) {
        _Notification.error({
          content: intl.t('图片大小不能超过2M'),
          duration: 2000
        });
        return false;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setImgSrc(reader.result);
      };
      reader.readAsDataURL(file);
      setFile(file);
      return false;
    }
  }, !imgSrc && !logo ? /*#__PURE__*/React.createElement("div", {
    className: "arco-upload-trigger-picture",
    style: {
      width: 80,
      height: 80
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "arco-upload-trigger-picture-text"
  }, /*#__PURE__*/React.createElement(_IconPlus, null))) : /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#eee'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imgSrc || logo,
    style: {
      maxWidth: 300,
      height: 100
    }
  })))), /*#__PURE__*/React.createElement(_Form.Item, {
    label: intl.t('还原')
  }, /*#__PURE__*/React.createElement(_Button, {
    style: {
      marginRight: 10
    },
    status: "danger",
    onClick: () => {
      EnvService.postResourceReset({
        type: 0
      }).then(() => {
        refresh();
        setVisible(false);
      });
    }
  }, "Aplux"), /*#__PURE__*/React.createElement(_Button, {
    status: "danger",
    onClick: () => {
      EnvService.postResourceReset({
        type: 1
      }).then(() => {
        refresh();
        setVisible(false);
      });
    }
  }, "Qualcomm")))));
};
export default Cpn;